<span class="chip" [attr.status]="status">
	<ng-content />
</span>
